import { Box, colors, InputBase } from "@mui/material"
import React from "react"

export const DateTimePicker = (props: {
	inputValue: string
	displayData: string
	leaveEditMode: () => void
	enterEditMode: () => void
	setInputValue: React.Dispatch<React.SetStateAction<string>>
	isEdit: boolean
}) => {
	const { inputValue, displayData, leaveEditMode, enterEditMode, setInputValue, isEdit } = props
	return !isEdit ? (
		<Box
			onClick={enterEditMode}
			sx={{
				height: "100%",
				p: "4px 8px 5px 8px",
				color: colors.grey[800],
				overflow: "hidden",
				whiteSpace: "nowrap",
				display: "flex",
				alignItems: "center",
			}}
		>
			{displayData}
		</Box>
	) : (
		<InputBase
			type="datetime-local"
			value={inputValue}
			onInput={(e: React.ChangeEvent<HTMLInputElement>) => setInputValue(e.target.value)}
			onBlur={leaveEditMode}
			autoFocus
			fullWidth
			sx={{
				height: "100%",
				px: "8px",
				color: colors.grey[800],
				boxSizing: "border-box",
				"&.Mui-focused": {
					border: 1,
					px: "7px",
					borderColor: "primary.main",
				},
				"input::-webkit-calendar-picker-indicator": {
					marginInlineStart: 0,
					opacity: 0.6,
				},
			}}
		/>
	)
}
